module.exports = __webpack_public_path__ + "static/media/Safe-T5.32c48d54.JPG";